import { AllIconKey, BrandSymbolKey, brandSymbolsMap, IconKey } from '@melio/penny';

export const isBrandSymbol = (icon: AllIconKey | IconKey | BrandSymbolKey): icon is BrandSymbolKey =>
  Boolean(Object.keys(brandSymbolsMap).includes(icon as BrandSymbolKey));
